<template>
  <div class="panel">
    <div class="title">自定义消息提醒
      <a-button v-if="!isEdit" class="title-btn" type="primary" @click="messageEdit(true)">设置</a-button>
      <template v-else>
        <a-button class="title-btn" type="primary" @click="messageAdd">添加</a-button>
        <a-button class="title-btn"  @click="messageEdit(false)">关闭</a-button>
      </template>
    </div>
    <a-table class='info' :columns='columns' :loading="loading" :dataSource='dataSource' :pagination='false'  rowKey='id' size='small'
             :customRow="customRowFn"
    >
            <span slot="action" slot-scope="text, record">
            <a-button size='small' type='primary' @click="handleEdit(record)">修改</a-button>
          <a-divider type="vertical" />
              <a-button size='small' type='danger' @click="handleDelete(record.id)">删除</a-button>
            </span>
    </a-table>
    <message-model ref="messageModel" @ok="loadData"></message-model>
  </div>
</template>

<script>
  import { getAction ,deleteAction} from '@/api/manage'
  import MessageModel from './modal/MessageModel'
  export default {
    name: 'MessageSet',
    components: { MessageModel },
    props:{
      projectId:{
        type:String,
        default:''
      }
    },
    data(){
      return {
        dataSource:[],
        isEdit:false,
        loading:false,
      }
    },
    computed:{
      columns(){
        const columns = [
          {
            title: '序号',
            width: 80,
            align:'center',
            customRender: (text, record, index) => index + 1
          },
          {
            title: '消息类型',
            dataIndex: 'type',
            align:'center',
            ellipsis: true,
          },
          {
            title: '消息内容',
            dataIndex: 'content',
            align:'center',
            ellipsis: true,
          },
          {
            title: '推送对象',
            dataIndex: 'groupNames',
            align:'center',
            ellipsis: true,
          },
          {
            title: '推送时间点',
            dataIndex: 'pushType',
            align:'center',
            ellipsis: true,
            customRender:(text)=>text==='1'?'个性化推送':'固定日期'
          },{
            title: '附带链接',
            dataIndex: 'link',
            align:'center',
            ellipsis: true,
          },
        ]
        if(this.isEdit){
          columns.push({
            title: '操作',
            scopedSlots: { customRender: 'action' }
          })
        }
        return columns
      }
    },
    mounted(){
      this.loadData()
    },
    methods:{
      loadData(){
        if(this.projectId){
          this.loading = true
          getAction('/project/projectPatientMsg/list').then(res=>{
            if(res.success){
              this.dataSource = res.result
            }
          }).finally(()=>{
            this.loading = false
          })
        }
      },
      handleDelete(id){
        this.$confirm({
          title: "确认删除",
          content: "是否删除选中数据?",
          onOk: ()=> {
            deleteAction('/project/projectPatientMsg/delete',{id:id}).then(res=>{
              if(res.success){
                this.loadData()
              }
            })
          }
        })

      },
      /**
       * 自定义消息提醒
       */
      messageEdit(isEdit) {
        this.isEdit = isEdit
      },
      messageAdd(){
        this.$refs['messageModel'].edit({projectId:this.projectId})
      },
      handleEdit(record){
        this.$refs['messageModel'].edit(record)
      },
      handleView(record){
        this.$refs['messageModel'].view(record)
      },
      customRowFn(record) {
        return {
          on: {
            dblclick: () => {
              this.handleView(record)
            }
          }
        }
      },
    }
  }
</script>

<style scoped>

</style>